<footer>
    <div class="footer-container">
      <div class="footer-logo">
        <img src="assets/CancianMenuLogo.png" alt="Logo" />
        <p>CRECI RS 23.676 J.</p>
      </div>
  <div class="footer-container-links">
  <div class="footer-links">
    <a (click)="acessaSobreNos()">Sobre Nós</a>
    <a (click)="acessaTermos()">Termos de Uso e Privacidade</a>
    <a (click)="acessaTrabalheConosco()">Trabalhe conosco</a>
  </div>
  <div class="footer-text-container">
    <p class="footer-text">© 2025 Cancian Imóveis</p>
  </div>
</div>
      <div class="footer-info">
        <div class="footer-social">
          <a href="https://www.facebook.com/CancianImoveis" target="_blank" aria-label="Facebook">
            <i class="fab fa-facebook-f"></i>
          </a>
          <a href="https://www.instagram.com/cancian_imoveis" target="_blank" aria-label="Instagram" style="font-size: 27px;">
            <i class="fab fa-instagram"></i>
          </a>
          <a href="https://www.youtube.com/@cancianimoveis4966" target="_blank" aria-label="YouTube" style="font-size: 32px;">
            <i class="fab fa-youtube"></i>
          </a>
        </div>
        <p><strong>Seg a Sex:</strong> 8h30 às 18h00<br/><strong>Sábado:</strong> 08h30 às 16h</p>
      </div>
    </div>
  </footer>
  